<template><div><h1 id="benutzergruppen-zuordnen" tabindex="-1"><a class="header-anchor" href="#benutzergruppen-zuordnen"><span>Benutzergruppen zuordnen</span></a></h1>
<p>Benutzergruppen zuordnen — Zuordnung von Benutzergruppen zu Benutzern</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame werden den <RouteLink to="/referenz/refs/ft.refdata.benutzer.html" title="Benutzerstamm">Benutzern</RouteLink> die <RouteLink to="/referenz/refs/ft.refdata.benutzergruppen.html" title="Benutzergruppen">Benutzergruppen</RouteLink> zugewiesen.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Benutzerverwaltung → Benutzergruppen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Benutzer</dt>
<dd>Kurzzeichen des Benutzers</dd>
<dt>Gruppe</dt>
<dd>Kurzzeichen der zugeordneten <a class="link" href="ft.refdata.benutzergruppen.html" title="Benutzergruppen">Benutzergruppe</a></dd>
<dt>Gruppenbezeichnung</dt>
<dd>Bezeichnung der zugeordneten Benutzergruppe</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>keine</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/benutzerverwaltung.html#Benutzerverwaltung" title="1. Benutzerverwaltung">Benutzerverwaltung</RouteLink></p>
</div></template>


